import { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { LoginContext } from '../contexts/login-context'
import { ApiProvider } from '../contexts/api-context'
import { MenuProvider } from '../contexts/menu-context'
import Header from '../components/header/header'

import Modal from '../components/modal/modal'

export const PrivateRoute = () => {
  const { authenticated, isLoading } = useContext(LoginContext)

  if (isLoading) {
    return <></>
  }

  if (!authenticated) {
    return <Navigate to="/login" />
  }

  return (
    <ApiProvider>
      <MenuProvider>
        <Modal />
        <Header />
        <Outlet />
      </MenuProvider>
    </ApiProvider>
  )
}
